import axiosInstance from "./axiosConfig";

export type MixpanelDocumentUploadedCountsQuery = {
  from_date: string;
  to_date: string;
  unit?: "day" | "week" | "month";
};

export type MixpanelSeriesPoint = {
  date: string;
  count: number;
};

export type MixpanelDocumentUploadedCountsResponse = {
  query_timestamp: string;
  event: string;
  from_date: string;
  to_date: string;
  unit: string;
  total: number;
  series: MixpanelSeriesPoint[];
};

export async function getDocumentUploadedCounts(
  query: MixpanelDocumentUploadedCountsQuery
): Promise<MixpanelDocumentUploadedCountsResponse> {
  const response =
    await axiosInstance.get<MixpanelDocumentUploadedCountsResponse>(
      "/admin/mixpanel/events/document-uploaded",
      { params: query }
    );
  return response.data;
}

export async function getLoginSuccessCounts(
  query: MixpanelDocumentUploadedCountsQuery
): Promise<MixpanelDocumentUploadedCountsResponse> {
  const response =
    await axiosInstance.get<MixpanelDocumentUploadedCountsResponse>(
      "/admin/mixpanel/events/login-success",
      { params: query }
    );
  return response.data;
}
